import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import ListItemAdvertisementContainer from './ListItemAdvertisementContainer'
import getData from '../../../functions/getData'
import { PROGRAM_ADVERTISEMENTS_ITEMS } from '../../../constants/state'
import { ADVERTISEMENT } from '../../../constants/itemTypes'

const mapStateToProps = (state, ownProps) => ({
    itemData:  getData(state, [PROGRAM_ADVERTISEMENTS_ITEMS, ownProps.itemId])
})

const ListItemDataAdvertisementContainer = ({
    itemId,
    itemData,
    additionalClass =  false,
    isSelected = false,
    pathnameEdit = false,
    onDeleteItem = false
}) => <ListItemAdvertisementContainer
    itemType={ADVERTISEMENT}
    itemData={itemData}
    additionalClass={additionalClass}
    isSelected={isSelected}
    pathnameEdit={pathnameEdit}
    onDelete={() => onDeleteItem(itemId)}
/>

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ListItemDataAdvertisementContainer)